import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { SERVICES } from "../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TRUST = ["★★★★★ Rated", "Fully Insured", "20+ Years", "Family Run"];

export default function LeadForm({ source = "website", compact = false, onSuccess, tid = "lead" }) {
  const [form, setForm] = useState({ name: "", telephone: "", email: "", address: "", service: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.telephone) {
      toast.error("Please provide your name and telephone number.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { ...form, source });
      toast.success("Thank you — we'll be in touch shortly.");
      setForm({ name: "", telephone: "", email: "", address: "", service: "", message: "" });
      onSuccess && onSuccess();
    } catch (err) {
      toast.error("Something went wrong. Please call us instead.");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-[#0D0D0D] border border-white/15 rounded-sm px-4 py-3 text-[#F8F8F8] placeholder:text-white/35 focus:outline-none focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37]/40 transition-colors";

  return (
    <form onSubmit={submit} data-testid={`${tid}-form`} className="space-y-4">
      <div className="flex flex-wrap gap-2 mb-2">
        {TRUST.map((t) => (
          <span key={t} className="text-[10px] sm:text-xs uppercase tracking-wider text-[#C8C8C8] border border-white/10 rounded-full px-3 py-1">{t}</span>
        ))}
      </div>
      <div className={compact ? "space-y-4" : "grid sm:grid-cols-2 gap-4"}>
        <input data-testid={`${tid}-name`} className={field} placeholder="Full Name*" value={form.name} onChange={set("name")} />
        <input data-testid={`${tid}-phone`} className={field} placeholder="Telephone*" value={form.telephone} onChange={set("telephone")} />
        <input data-testid={`${tid}-email`} className={field} placeholder="Email" value={form.email} onChange={set("email")} />
        <input data-testid={`${tid}-address`} className={field} placeholder="Property Address" value={form.address} onChange={set("address")} />
      </div>
      <select data-testid={`${tid}-service`} className={field + " text-white/80"} value={form.service} onChange={set("service")}>
        <option value="">Service Required</option>
        {SERVICES.map((s) => <option key={s.slug} value={s.title}>{s.title}</option>)}
      </select>
      <textarea data-testid={`${tid}-message`} rows={compact ? 3 : 4} className={field} placeholder="Tell us about your project" value={form.message} onChange={set("message")} />
      <motion.button
        type="submit" data-testid={`${tid}-submit`} disabled={loading}
        whileTap={{ scale: 0.98 }}
        className="btn-gold w-full rounded-sm py-4 text-sm disabled:opacity-60"
      >
        {loading ? "Sending…" : "Request My Free Quote"}
      </motion.button>
    </form>
  );
}
